import { AsyncPipe, CommonModule, CurrencyPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CategoriesGridComponent } from './components/categories-grid/categories-grid.component';
import { DividerComponent } from './components/divider/divider.component';

import { ConvertToNumberPipe, LetDirective } from './directives';
import { CancelationPoliciesDetailsComponent } from './modals/cancelation-policies-details/cancelation-policies-details.component';
import { PropertyTimezonePipe } from './pipes/property-tz.pipe';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  NgIf,
  AsyncPipe,
  LetDirective,
  DividerComponent,
  ConvertToNumberPipe,
  CancelationPoliciesDetailsComponent,
  CurrencyPipe,
  PropertyTimezonePipe,
  CategoriesGridComponent,
  PropertyTimezonePipe,
];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES],
})
export class SharedModule {}
